'use client';

import { useContext } from 'react';

import {
  CommunityMessageContext,
  type CommunityMessageContextValue,
} from './context';

/**
 * Read the nearest `CommunityMessageProvider`. Throws when called
 * outside a provider — every consumer (bubble, list, composer)
 * sits under one in the channel / thread shells.
 */
export function useCommunityMessageContext(): CommunityMessageContextValue {
  const value = useContext(CommunityMessageContext);
  if (!value) {
    throw new Error(
      'useCommunityMessageContext must be called inside <CommunityMessageProvider>',
    );
  }
  return value;
}
